// Store
import {setLoading} from './generalActions';
import {AppDispatch} from '../../store';
import ContainerShipmentServices from '../../../api/containerShipmentServices';
import ctnServices from '../../../api/ctnServices';

// Types
import {containerShipmentTypes} from '../types';
import {PaginationType} from '../../../types/sharedTypes';
import {ContainerShipmentType} from '../../../types/containerShipmentTypes';
import moment from 'moment';

// Components and Subcomponents
import {ERROR_MODAL, SUCCESS_MODAL} from '../../../components/subComponents/responseModals';

// Constants
import {UPDATE_CONTAINER_SHIPMENT} from '../../../utils/constants';
import { base64ToFile } from '../../../utils/functions';


export const getParams = (data: PaginationType) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.getParams()
    .then((response) => {
      dispatch({
        type: containerShipmentTypes.GET_CONTAINER_SHIPMENT_PARAMS,
        params: response.data
      });
      dispatch(getAllContainerShipments(data));
    })
    .catch(err => {
      ERROR_MODAL(err.data.message);
      dispatch(setLoading(false));
    })
}
export const getAllContainerShipments = (data: PaginationType) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.getAll(data)
    .then((response) => {
      dispatch({
        type: containerShipmentTypes.GET_ALL_CONTAINER_SHIPMENTS,
        containerShipmentResult: response.data
      });
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const getAllContainersInProcess = () => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.getAllContainersInProcess()
    .then((response) => {
      dispatch({
        type: containerShipmentTypes.GET_ALL_CONTAINERS_IN_PROCESS,
        containersInProcess: response.data
      });
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const getContainerShipmentSchedule = (month: number, year: number) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  const startDate = moment({ year, month, date: 1 }).startOf('month').toDate();
  const endDate = moment(startDate).endOf('month').toDate();

  try {
    const response = await ContainerShipmentServices.getSchedule(startDate, endDate);
    const scheduleData = Array.isArray(response.data) ? response.data : response.data?.rows ?? [];
    dispatch({
      type: containerShipmentTypes.GET_CONTAINER_SHIPMENT_SCHEDULE,
      schedule: scheduleData
    });
  } catch (err: any) {
    ERROR_MODAL(err?.data?.error || err?.message || 'No se pudo cargar el calendario de contenedores.');
  } finally {
    dispatch(setLoading(false));
  }
}
export const getAllContainerShipmentsByDownloadDate = (downloadDate: Date) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.getByDownloadDate(downloadDate)
    .then((response) => {
      dispatch({
        type: containerShipmentTypes.GET_CONTAINER_SHIPMENT_BY_DOWNLOAD_DATE,
        containerShipmentResultByDownloadDate: response.data
      });
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const recalculateShipmentQuantities = (shipmentId: string, pagination: PaginationType) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.recalculateShipmentQuantities(shipmentId)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getAllContainerShipments(pagination));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const setDownloadShimpmentDate = (shipmentId: string, downloadDate: Date | null, recordsDate?: Date) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.setDownloadShimpmentDate(shipmentId, downloadDate)
    .then(() => {
      dispatch(getContainerShipmentSchedule(moment(downloadDate ?? recordsDate).month(), moment(downloadDate ?? recordsDate).year()));
      dispatch(getAllContainerShipmentsByDownloadDate(downloadDate ?? recordsDate ?? new Date()));
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const updateContainerShipment = (containerShipment: ContainerShipmentType, postUpload: string, downloadDate?: Date) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.update(containerShipment)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      switch (postUpload) {
        case UPDATE_CONTAINER_SHIPMENT.schedule:
          dispatch(getContainerShipmentSchedule(moment(containerShipment.scheduledUnloadingDate).month(), moment(containerShipment.scheduledUnloadingDate).year()));
          dispatch(getAllContainerShipmentsByDownloadDate(downloadDate ?? new Date()));
          break;
        case UPDATE_CONTAINER_SHIPMENT.getAll:
          dispatch(getAllContainerShipments({ page: 1, size: 10 }));
          break;
      }
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const uploadShipmentFile = (formData: FormData) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ctnServices.upload(formData)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getAllContainerShipments({ page: 1, size: 10 }));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const downloadFile = (startDate: Date, endDate: Date) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  ContainerShipmentServices.downloadScheduleFile(startDate, endDate)
    .then((response) => {
      base64ToFile(response.data.file, response.data.fileName);
      dispatch(setLoading(false));
    })
    .catch(response => {
      ERROR_MODAL(response.data.error);
      dispatch(setLoading(false));
    })
}